// extracted by mini-css-extract-plugin
module.exports = {"form":"DispatchForm_form___dKbR"};